import React from 'react';
import styled from 'styled-components';

interface Props {
	message: string;
}

const ErrorMessage = styled.h4`
	margin: auto;
	text-align: center;
	margin-top: 5rem;
`;

export const Error: React.FC<Props> = (props: Props) => (
	<ErrorMessage>
		{props.message
			? props.message
			: 'Jotain meni vikaan, yritä myöhemmin uudestaan.'}
	</ErrorMessage>
);
